import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../context/AuthContext";

export function useUser() {
  const { isLoaded, isSignedIn, user } = useAuthContext();
  return { isLoaded, isSignedIn, user };
}

export function useAuth() {
  const { isSignedIn, signOut, getToken } = useAuthContext();
  return { isSignedIn, signOut, getToken };
}

export function Show({ when, children }) {
  const { isLoaded, isSignedIn } = useAuthContext();
  if (!isLoaded) return null;
  if (when === "signed-in") return isSignedIn ? children : null;
  if (when === "signed-out") return !isSignedIn ? children : null;
  return null;
}

export function SignInButton({ children }) {
  const navigate = useNavigate();
  return (
    <span onClick={() => navigate("/sign-in")} style={{ display: "contents", cursor: "pointer" }}>
      {children}
    </span>
  );
}
